import type { IpGeoLocation } from "~/types/GeoLocation";

export default function useGeoIpLocation(): {
  fetchGeoIpLocation: () => Promise<IpGeoLocation | undefined>;
  ipGeoLocation: ReturnType<typeof useState<IpGeoLocation>>;
  isUsCaUser: ComputedRef<boolean>;
} {
  const { $goodbits } = useNuxtApp();
  const ipGeoLocation = useState<IpGeoLocation>("ipGeoLocation");

  const fetchGeoIpLocation = async () => {
    if (import.meta.server && ipGeoLocation.value) {
      return;
    }

    try {
      const { data } = await $goodbits<{ data: IpGeoLocation }>(
        "/utilities/v1/ip-geolocation",
      );
      ipGeoLocation.value = data;
      return ipGeoLocation.value;
    } catch (error) {
      // Handle error if needed
      console.error("Error fetching IP geolocation:", error);
    }
  };

  const isUsCaUser = computed(() =>
    ["US", "CA"].includes(ipGeoLocation.value?.countryCode),
  );

  return {
    fetchGeoIpLocation,
    ipGeoLocation,
    isUsCaUser,
  };
}
